import { useLocation, useNavigate } from "react-router-dom";
import classes from "./OloLogin.module.css";
import { useEffect } from "react";
import { getAccessTokenOloLogin, getCartById, getuserInfo, oneTimeSigninLink } from "../scripts/fetchApi";
import { useDispatch, useSelector } from "react-redux";
import { variousActions } from "../store/various";
import { authActions } from "../store/auth";
import { setSessionStorageItem } from "../scripts/localStorage";

const OloLogin = () => {
    const location = useLocation();
    const dispatch = useDispatch();
    const navigate = useNavigate()
    const cart = useSelector(state => state.cart.cart)
    let hasLocation = useSelector(state => state.location.location)
    const sParams = new URLSearchParams(location.search);

    console.log("location:::: ", sParams);

    const params = Object.fromEntries(sParams.entries());
    console.log("params:::: ", params); // {one: '1', two: '2'}

    useEffect(() => {

        const g = async () => {
            const a = await getAccessTokenOloLogin({
                grant_type: "authorization_code",
                code: params.code,
                redirect_uri: process.env.REACT_APP_OLO_BORDERLESS_REDIRECT_URI,
                scope: params.scope,
                client_id: process.env.REACT_APP_OLO_BORDERLESS_CLIENT_ID,
                client_secret:process.env.REACT_APP_OLO_BORDERLESS_CLIENT_SECRET,
                auth_url: process.env.REACT_APP_OLO_BORDERLESS_AUTH_API,
            });
            console.log("a::::: ", a);

            if (a && a.authtoken) {
                //we have a token, redirect to account?
                dispatch(authActions.oloLogin(a))
                const user = await getuserInfo(a.authtoken, 'oloauth')
                if (user) {
                    console.log('olo user:::::::::: ', user)
                    const formatUser = {
                        first_name: user.firstname ? user.firstname : '',
                        last_name: user.lastname ? user.lastname : '',
                        name: (user.firstname ? user.firstname : '') + ' ' + (user.lastname ? user.lastname : ''),
                        email: user.emailaddress,
                        phone: user.phone ? user.phone : '',
                    }
                    // dispatch(authActions.oloLogin({authtoken: a.data?.authtoken}))
                    dispatch(authActions.setUser(formatUser))


                    if (cart) {
                        const getCart = await getCartById(cart.id, a.authtoken) // this apparently gets the current cartand if it exists it adds it to the logged in user? TODO / TOCHECK
    
                        if (getCart.id) {
                            // setStorageItem('currentCart', getCart)
                            setSessionStorageItem('currentCart', getCart)
                        }
                    }
                }

                // if (cart) {
                //     const getCart = await getCartById(cart.id, a.authtoken) // this apparently gets the current cartand if it exists it adds it to the logged in user? TODO / TOCHECK

                //     if (getCart.id) {
                //         // setStorageItem('currentCart', getCart)
                //         setSessionStorageItem('currentCart', getCart)
                //     }
                // }
                if (hasLocation) {
                    navigate(`/${hasLocation.slug}/menu`)
                } else {
                    navigate('/')
                }


            } else {
                dispatch(variousActions.setError({message: 'Something went wrong, please try again.'})) 
                navigate('/')
            }
        };

        g();
    }, []);

    return (
        <div className="container-full">
            <div className={classes.olo_login_container}>
                <h1>Olo login</h1>
                <p>Please wait while we process your request...</p>
                <span className="loader dark"></span>
            </div>
        </div>
    );
};

export default OloLogin;
